import OrdersTable from "./OrdersTable";

const DelayPickingOrder = () => {
  return <OrdersTable type="delay-picking" />;
};

export default DelayPickingOrder;
